import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/ExposureApi/';

// 保存曝光数据
export const addExposure = (data)=>{
  return getInterface.post(`${prefixUrl}addExposure`, data);
}
// 曝光数据 List
export const queryExposureList = (data)=>{
  return getInterface.post(`${prefixUrl}queryExposureList`, data);
}